import { addPolygonRange, removePolygonRange } from 'Pods/SearchPage/Store/actions/polygon'
import { setSimulationReady } from 'Pods/SearchPage/Store/actions/simulationReady'
import {
  setAnimated, setPbr, setRigged, setGameReady, setWithRenders,
} from 'Pods/SearchPage/Store/actions/threeDOnly'
import {
  setMultipleParts, setPreSupported, setThreeDPrintVerified, setWithMakes,
} from 'Pods/SearchPage/Store/actions/threeDPrintOnly'
import { POLYGON_RANGE } from 'Pods/SearchPage/Store/constants'

const handleLowPolyChange = (isOn) => {
  if (isOn) {
    addPolygonRange(POLYGON_RANGE.LOW_POLY)
  } else {
    removePolygonRange(POLYGON_RANGE.LOW_POLY)
  }
}

export const FEATURES = [
  {
    value: 'animated',
    labelKey: 'technical_attributes.animated',
    select: state => state.animated,
    onChange: setAnimated,
  },
  {
    value: 'pbr',
    labelKey: 'technical_attributes.pbr',
    select: state => state.pbr,
    onChange: setPbr,
  },
  {
    value: 'rigged',
    labelKey: 'technical_attributes.rigged',
    select: state => state.rigged,
    onChange: setRigged,
  },
  {
    value: 'low_poly',
    labelKey: 'technical_attributes.low_poly',
    select: state => state.polygonRanges.includes(POLYGON_RANGE.LOW_POLY),
    onChange: handleLowPolyChange,
  },
  {
    value: 'game_ready',
    labelKey: 'features.game_ready',
    select: state => state.gameReady,
    onChange: setGameReady,
  },
  {
    value: 'with_renders',
    labelKey: 'features.with_renders',
    select: state => state.withRenders,
    onChange: setWithRenders,
  },
  {
    value: 'simulation_ready',
    labelKey: 'features.simulation_ready',
    select: state => state.simulationReady,
    onChange: setSimulationReady,
  },
]

// The 3D features the secondary row has no checkbox for. Figma lists them only in the mobile drawer
// (2807:155269), so the desktop More filters popover carries them to keep them reachable from 960.
export const POPOVER_FEATURES = FEATURES.filter(({ value }) => ['game_ready', 'with_renders'].includes(value))

// The 3D-print counterpart of FEATURES: the same checkboxes as the PrintAttributes row.
export const PRINT_FEATURES = [
  {
    value: 'with_makes',
    labelKey: 'print_attributes.with_makes',
    select: state => state.withMakes,
    onChange: setWithMakes,
  },
  {
    value: 'three_d_print_verified',
    labelKey: 'print_attributes.three_d_print_verified',
    select: state => state.threeDPrintVerified,
    onChange: setThreeDPrintVerified,
  },
  {
    value: 'pre_supported',
    labelKey: 'print_attributes.pre_supported',
    select: state => state.preSupported,
    onChange: setPreSupported,
  },
  {
    value: 'multiple_parts',
    labelKey: 'print_attributes.multiple_parts',
    select: state => state.multipleParts,
    onChange: setMultipleParts,
  },
  {
    value: 'simulation_ready',
    labelKey: 'features.simulation_ready',
    select: state => state.simulationReady,
    onChange: setSimulationReady,
  },
]

export const DEFAULT_LIMIT = 4
